<template>
  <div>
    <div style="background-color: #fff; padding-bottom: 30px">
      <mdb-container>
        <mdb-row>
          <div class="progress__container">
            <img :src="treeImg" style="width: 100%; height: auto" alt />
          </div>
        </mdb-row>
      </mdb-container>
    </div>
    <div style="background-color: #f7f7f7" class="mt-1 pt-1 cardClass">
      <mdb-container
        style="
          max-width: 97% !important;
          padding-bottom: 2rem;
          background-color: #fff;
          -webkit-box-shadow: 0px 6px 15px 0px rgba(0, 0, 0, 0.34);
          -moz-box-shadow: 0px 6px 15px 0px rgba(0, 0, 0, 0.34);
          box-shadow: 0px 6px 15px 0px rgba(0, 0, 0, 0.34);
        "
        class="mt-5"
      >
        <mdb-row class="pt-5 pr-5 pb-5">
             <mdb-col md="2">
            
          </mdb-col>
          <mdb-col md="6" style="padding-left: 8rem;" >
            <span class="text-style">CORREGIR DATOS</span>
            <p style="font-size: 14px; font-weight: 400;">Estimado solicitante, favor de realizar las siguientes correciones de documentos y/o datos que se señalan a continuación</p>
          </mdb-col>
          <mdb-col md="1" class="text-right" style="margin-left: 24%">
            <p
              style="
                font-size: 30px;
                cursor: pointer;
                color: #e0e0e0;
                font-weight: 700;
              "
              @click="closeMessageError()"
            >
              x
            </p>
          </mdb-col>
        </mdb-row>

        <mdb-col md="10" style="margin: auto; width: 60%">
          <div>
            <div>                
              <mdb-row>
                <mdb-col md="9">
                  <div class="Rectangle-78" style="font-size: 15px; font-weight: 600;">
                    <div v-for="(correction, index) in correctionsSpouse" :key="'correction'+index">
                    <ul v-for="doc in correction.documents" :key="doc.id">
                      <li v-if="doc.documentType == 'PROFILE_PICTURE' && doc.comment">
                        {{ doc.comment }}
                      </li>
                    </ul>
                    <ul v-if="correction.laborData.comment">
                      <li>{{ correction.laborData.comment }}</li>
                    </ul>
                    </div>
                  </div>
                </mdb-col>
              </mdb-row>
               <mdb-row class="mt-5 text-center">
                <mdb-col md="9">
                   <span style="font-size: 14px; font-weight: 600; color: red;">POR FAVOR, SUBE E INGRESA SOLO LOS DATOS QUE SE TE MENCIONAN</span> 
                </mdb-col>
              </mdb-row>
                     <mdb-row class="mt-5 text-left">
                <mdb-col md="9">
                  <span class="text-style-2">CÓNYUGE</span>
                </mdb-col>
              </mdb-row>
             
              <mdb-row style="margin-top: 2%; width: 100%">
                <mdb-col md="3" style="text-align: right">
                  <div v-if="fileAvatar == ''" class="image-upload">
                    <label for="image-release">
                      <img
                        @mouseup="mouseUpIcon('release')"
                        @mousedown="mouseDownIcon('release')"
                        @mouseleave="mouseLeaveIcon('release')"
                        @mouseover="mouseOverIcon('release')"
                        @click="
                          $refs.camera.toggleModal();
                          $refs.webcam.start();
                        "
                        :src="'/img/icons/' + releaseIcon"
                        class="icon"
                        alt="agregar foto"
                        style="cursor: pointer"
                      />
                    </label>
                    <!-- <input
                      type="file"
                      accept="image/jpg, image/png"
                      name="file"
                      id="image-release"
                      @change="uploadFile"
                    />-->
                  </div>
                  <div v-else class="image-upload input-group mb-5">
                    <img
                      :src="fileAvatar"
                      class="avatar-pic"
                      alt="Profile Picture"
                    />
                    <img
                      :src="'/img/icons/editar-foto.svg'"
                      class="edit-pic"
                      alt="Profile Picture"
                      style="cursor: pointer"
                      @click="
                        $refs.camera.toggleModal();
                        $refs.webcam.start();
                      "
                    />

                    <!-- <input
                      type="file"
                      accept="image/jpg, image/png"
                      name="file"
                      id="image-release"
                      @change="uploadFile"
                    />-->
                  </div>
                </mdb-col>
              </mdb-row>
 
              <mdb-row class="mt-5" style="margin-left: 3%">
                <mdb-col md="12">
                  <div class="form__group">
                    <label class="form__label" style="cursor: unset !important"
                      >IDENTIFICACIONES</label
                    >
                  </div>
                </mdb-col>

                <mdb-col md="12" style="margin-left: -5%">
                  <div
                    style="
                      border: 1px solid #3a8a65;
                      border-radius: 5px;
                      padding: 4rem;
                    "
                  >
                   
                    <div class="form__group mt-5">
                      <label
                          for="curpSection"
                          class="form__label mb-3"
                          style="transform: translateY(3px); cursor:auto;"
                          >Sube tu CURP <small>(Actualizada, legible)</small>:
                          <br />
                          <span
                              style="
                                font-size: 12px;
                                font-weight: 600;
                                color: #000;
                              "
                            >
                              Puedes generarla aquí:
                              <a href="https://www.gob.mx/curp/" target="_blank"
                                >https://www.gob.mx/curp/</a
                              >
                            </span>
                      </label>
                      <div v-show="fileCurp == null" id="curpSection" class="form__group">
                       
                        <mdb-row>
                          <mdb-col md="4">
                            <label for="curp-input" class="btn-label">
                              <img
                                :src="'/img/icons/' + uploadIcon"
                                style="width: 20px"
                              />
                              SUBIR CURP
                            </label>
                            <input
                              type="file"
                              accept="application/pdf"
                              name="file"
                              id="curp-input"
                              style="visibility: hidden"
                              @change="uploadCURP"
                            />
                          </mdb-col>
                        </mdb-row>
                      </div>
                      <validation-error
                        :validation="$v.fileCurp"
                      ></validation-error>
                      <div v-show="fileCurp != null" class="input-group">
                        <btn
                          :text="'ver CURP'"
                          :type="'primary-admin'"
                          icon="revisar"
                          style="float: left"
                           @onClick="viewPdf(fileCurp, 'CURP')"
                        ></btn>

                        <!-- <img
                          style="margin-top: 10px; cursor: pointer"
                          :src="'/img/icons/' + watchButton"
                          @click="viewPdf(fileCurp, 'CURP')"
                          @mouseup="mouseUpIcon('watch')"
                          @mousedown="mouseDownIcon('watch')"
                          @mouseleave="mouseLeaveIcon('watch')"
                        /> -->

                        <button
                          type="button"
                          class="btn btn-delete"
                          @click="fileCurp = null"
                          style="padding: 3px; position: inherit; top: 4px;">
                          <img
                            :src="'/img/icons/InoBorrar.svg'"
                            alt="icon eliminar"
                          />
                        </button>
                      </div>
                    </div>
                    <div class="form__group mt-5">
                        <label
                          for="idSection"
                          class="form__label mb-3"
                          style="transform: translateY(3px); cursor:auto;"
                          >Sube tu Identificación <small>(Vigente, legible, escaneada, ambos lados)</small>:</label
                        >
                      <div v-show="fileIne == null" id="idSection" class="form__group">
                      
                        <mdb-row>
                          <mdb-col md="4">
                            <label for="id-input" class="btn-label">
                              <img
                                :src="'/img/icons/' + uploadIcon"
                                style="width: 20px"
                              />
                              SUBIR IDENTIFICACIÓN
                            </label>
                            <input
                              type="file"
                              accept="application/pdf"
                              name="file"
                              id="id-input"
                              style="visibility: hidden"
                              @change="UploadIdentificacion"
                          /></mdb-col>
                          <mdb-col>
                            <div
                              style="
                                font-size: 12px;
                                font-weight: 600;
                                color: #000;
                              "
                            >
                              La identificación debe estar vigente
                            </div>
                          </mdb-col>
                        </mdb-row>
                      </div>
                      <validation-error
                        :validation="$v.fileIne"
                      ></validation-error>
                      <div v-show="fileIne != null" class="input-group">
                        <btn
                          :text="'Ver identificación'"
                          :type="'primary-admin'"
                          icon="revisar"
                          style="float: left"
                          @onClick="viewPdf(fileIne, 'Identificación')"
                        ></btn>

                        <!-- <img
                          style="margin-top: 10px; cursor: pointer"
                          :src="'/img/icons/' + watchButton"
                          @click="viewPdf(fileIne, 'Identificación')"
                          @mouseup="mouseUpIcon('watch')"
                          @mousedown="mouseDownIcon('watch')"
                          @mouseleave="mouseLeaveIcon('watch')"
                        /> -->
                         <button
                          type="button"
                          class="btn btn-delete"
                          @click="fileIne = null"
                          style="padding: 3px; position: inherit; top: 4px;">
                          <img
                            :src="'/img/icons/InoBorrar.svg'"
                            alt="icon eliminar"
                          />
                        </button>
                      </div>
                    </div>

                    <div class="form__group mt-5">
                      <label
                          for="actaSection"
                          class="form__label mb-3"
                          style="transform: translateY(3px); cursor:auto;"
                          >Sube tu Acta de Nacimiento <small>(Actualizada, escaneada, legible)</small>:</label
                        >
                      <div v-show="actaUrl == null" id="actaSection" class="form__group">
                        
                        <mdb-row>
                          <mdb-col md="4">
                            <label for="acta-input" class="btn-label">
                              <img
                                :src="'/img/icons/' + uploadIcon"
                                style="width: 20px"
                              />
                              SUBIR ACTA
                            </label>
                            <input
                              type="file"
                              accept="application/pdf"
                              name="file"
                              id="acta-input"
                              style="visibility: hidden"
                              @change="uploadActa"
                            />
                          </mdb-col>
                          <mdb-col>
                            <div
                              style="
                                font-size: 12px;
                                font-weight: 600;
                                color: #000;
                              "
                            >
                              El acta de nacimiento debe estar actualizada.
                            </div>
                          </mdb-col>
                        </mdb-row>
                      </div>
                      <validation-error
                        :validation="$v.actaUrl"
                      ></validation-error>
                      <div v-show="actaUrl != null" class="input-group">
                        <btn
                          :text="'Ver acta'"
                          :type="'primary-admin'"
                          style="float: left"
                          icon="revisar"
                          @onClick="viewPdf(actaUrl, 'Acta de nacimiento')"
                        ></btn>

                        <!-- <img
                          style="margin-top: 10px; cursor: pointer"
                          :src="'/img/icons/' + watchButton"
                          @click="viewPdf(actaUrl, 'Acta de nacimiento')"
                          @mouseup="mouseUpIcon('watch')"
                          @mousedown="mouseDownIcon('watch')"
                          @mouseleave="mouseLeaveIcon('watch')"
                        /> -->
                         <button
                          type="button"
                          class="btn btn-delete"
                          @click="actaUrl = null"
                          style="padding: 3px; position: inherit; top: 4px;">
                          <img
                            :src="'/img/icons/InoBorrar.svg'"
                            alt="icon eliminar"
                          />
                        </button>
                      </div>
                    </div>

                   
            
                  </div>
                </mdb-col>
                <mdb-col md="12"></mdb-col>
              </mdb-row>


              <mdb-row  class="mt-5" style="margin-left: 3%">
                <mdb-col md="12">
                  <div class="form__group">
                    <label class="form__label" style="cursor: unset !important">
                      DATOS LABORALES
                  
                    </label>
                  </div>
                </mdb-col>
                <mdb-col v-if="working" md="12" style="margin-left: -5%">
                  <div
                    style="
                      border: 1px solid #3a8a65;
                      border-radius: 5px;
                      padding: 4rem;
                    "
                  >
                    <mdb-row>
                      <mdb-col md="6">
                        <label for="input_name" class="form__label"
                          >Nombre de la empresa:</label
                        >
                        <input
                          type="text"
                          id="input_name"
                          class="form__input"
                          v-model="nameCompany"
                        />
                        <validation-error
                          :validation="$v.nameCompany"
                        ></validation-error>
                      </mdb-col>
                                            <mdb-col md="6">
                        <label for="input_profesion" class="form__label"
                          >Profesión:</label
                        >
                        <input
                          type="text"
                          maxlength="100"
                          id="input_profesion"
                          class="form__input"
                          v-model="profession"
                        />

                        <validation-error
                          :validation="$v.profession"
                        ></validation-error>
                        
                      </mdb-col>
                       <mdb-col md="6">
                        <label for="input_puesto" class="form__label"
                          >Puesto:</label
                        >
                        <input
                          type="text"
                          maxlength="100"
                          id="input_puesto"
                          class="form__input"
                          v-model="currentPosition"
                        />
                        <validation-error
                          :validation="$v.currentPosition"
                        ></validation-error>
                      </mdb-col>
                      <mdb-col md="6">
                        <label for="input_giro" class="form__label"
                          >Giro de la empresa:</label
                        >
                        <input
                          type="text"
                          maxlength="100"
                          id="input_giro"
                          class="form__input"
                          v-model="businessActivity"
                         
                        />
                        <validation-error
                          :validation="$v.currentPosition"
                        ></validation-error>

                      </mdb-col>
                      <mdb-col md="12">
                        <label for="input_direccion" class="form__label"
                          >Dirección de la empresa:</label
                        >
                        <input
                          type="text"
                          maxlength="300"
                          id="input_direccion"
                          class="form__input"
                          v-model="addressCompany"
                        />

                        <validation-error
                          :validation="$v.addressCompany"
                        ></validation-error>
                      </mdb-col>
                      <mdb-col md="6">
                        <label for="input_last" class="form__label"
                          >Teléfono de la empresa:</label
                        >
                        <input
                          type="text"
                          id="input_last"
                          class="form__input"
                          v-model="phoneCompany"
                          v-mask="'##########'"
                        />

                        <validation-error
                          :validation="$v.phoneCompany"
                        ></validation-error>
                      </mdb-col>
                    </mdb-row>
                       <mdb-row class="mt-4">
                      <mdb-col md="6">
                        <label for="buttonUpload" class="form__label"
                          >Subir constancia de situación fiscal a su nombre (Con sus datos, no de la empresa donde labora o laboro):</label
                        >
                        <div v-show="pdfUrl == null" class="curp-upload">
                          <label for="worker-input" class="btn-label">
                            <img
                              :src="'/img/icons/' + uploadIcon"
                              style="width: 20px"
                            />
                            SUBIR CONSTANCIA
                          </label>
                          <input
                            type="file"
                            accept="application/pdf"
                            name="file"
                            id="worker-input"
                            @change="uploadWorker"
                          />
                          <validation-error
                            :validation="$v.worker"
                          ></validation-error>
                        </div>
                        <div v-show="pdfUrl != null" class="input-group">
                          <btn
                            :text="'Ver constancia'"
                            :type="'primary-admin'"
                            style="float: left"
                            icon="revisar"
                            @onClick="viewPdf(pdfUrl, 'Constancia de situación fiscal')"></btn>

                          <!-- <img
                            style="margin-top: 10px; cursor: pointer"
                            :src="'/img/icons/' + watchButton"
                            @click="
                              viewPdf(pdfUrl, 'Constancia de situación fiscal')
                            "
                            @mouseup="mouseUpIcon('watch')"
                            @mousedown="mouseDownIcon('watch')"
                            @mouseleave="mouseLeaveIcon('watch')"
                          /> -->
                           <button
                          type="button"
                          class="btn btn-delete"
                          @click="pdfUrl = null"
                          style="padding: 3px; position: inherit; top: 4px;">
                          <img
                            :src="'/img/icons/InoBorrar.svg'"
                            alt="icon eliminar"
                          />
                        </button>
                        </div>
                      </mdb-col>
                      <mdb-col md="6">
                        <div
                          style="font-size: 12px; font-weight: 600; color: #000"
                        >
                          Asegúrate de subir todas las hojas de tu constancia.
                        </div>
                      </mdb-col>
                    </mdb-row>
                  </div>
                </mdb-col>
                <mdb-col v-else md="12" style="margin-left: -5%">
                  <div
                    style="
                      border: 1px solid #3a8a65;
                      border-radius: 5px;
                      padding: 4rem;
                    "
                  >
                  <mdb-row>
                      <mdb-col md="12">
                        <label for="input_name" class="form__label">
                          ¿A qué se dedica?
                          <small>Describa tal y cómo se lo solicitan en la corrección.</small>
                        </label>
                        <textarea
                          v-model="activityDescription"
                          rows="3"
                          class="form__input"
                        ></textarea>
                        <validation-error
                          :validation="$v.activityDescription"
                        ></validation-error>
                      </mdb-col>
                  </mdb-row>
                     <mdb-row class="mt-4">
                      <mdb-col md="6">
                        <label for="buttonUpload" class="form__label"
                          >Subir constancia de situación fiscal a su nombre (Con sus datos, no de la empresa donde labora):</label
                        >
                        <div v-show="pdfUrl == null" class="curp-upload">
                          <label for="worker-input" class="btn-label">
                            <img
                              :src="'/img/icons/' + uploadIcon"
                              style="width: 20px"
                            />
                            SUBIR CONSTANCIA
                          </label>
                          <input
                            type="file"
                            accept="application/pdf"
                            name="file"
                            id="worker-input"
                            @change="uploadWorker"
                          />
                          <validation-error
                            :validation="$v.worker"
                          ></validation-error>
                        </div>
                        <div v-show="pdfUrl != null" class="input-group">
                          <btn
                            :text="'Ver constancia'"
                            :type="'primary-admin'"
                            style="float: left"
                            icon="revisar"
                            @onClick="viewPdf(pdfUrl, 'Constancia de situación fiscal')"></btn>

                          <!-- <img
                            style="margin-top: 10px; cursor: pointer"
                            :src="'/img/icons/' + watchButton"
                            @click="
                              viewPdf(pdfUrl, 'Constancia de situación fiscal')
                            "
                            @mouseup="mouseUpIcon('watch')"
                            @mousedown="mouseDownIcon('watch')"
                            @mouseleave="mouseLeaveIcon('watch')"
                          /> -->
                           <button
                          type="button"
                          class="btn btn-delete"
                          @click="pdfUrl = null"
                          style="padding: 3px; position: inherit; top: 4px;">
                          <img
                            :src="'/img/icons/InoBorrar.svg'"
                            alt="icon eliminar"
                          />
                        </button>
                        </div>
                      </mdb-col>
                      <mdb-col md="6">
                        <div
                          style="font-size: 12px; font-weight: 600; color: #000"
                        >
                          Asegúrate de subir todas las hojas de tu constancia.
                        </div>
                      </mdb-col>
                    </mdb-row>
                  </div>
                </mdb-col>
              </mdb-row>

              <mdb-row class="mt-5" style="padding-left: 45%;">
               
                <mdb-col md="12" style="margin-left: -5%; ">
                  
                 <!-- <btn
                        :text="'CANCELAR'"
                        :type="'ghost'"
                        @onClick="closeMessageError()"
                      ></btn> -->
                    <btn
                    @onClick="readyToSend"
                    :text="'ENVIAR DATOS/DOCUMENTOS ACTUALIZADOS'"
                    :type="
                      fileAvatar &&
                      fileCurp &&
                      fileIne &&
                      actaUrl &&
                      ((working && pdfUrl && nameCompany != '' && profession != '' && addressCompany != '' && businessActivity != '' && phoneCompany != '' && currentPosition != '' )
                        ||
                      (!working && activityDescription != ''))
                        ? 'primary-block'
                        : 'disabled'
                    "
                  ></btn>
                </mdb-col>
              </mdb-row>
         
            




            </div>
            <!---FLAG-->
          </div>
        </mdb-col>
      </mdb-container>
    </div>

    <Loader v-show="isLoading" />
    <Popup ref="camera" size="md">
      <div class="text-center">
        <mdb-row>
          <mdb-col md="6">
            <mdb-row>
              <h2>Cámara</h2>
              <div class="border">
                <vue-web-cam
                  ref="webcam"
                  :device-id="deviceId"
                  width="100%"
                  height="100%"
                  @started="onStarted"
                  @stopped="onStopped"
                  @error="onError"
                  @cameras="onCameras"
                  @camera-change="onCameraChange"
                />
              </div>
            </mdb-row>
            <mdb-row>
              <div class="col-md-12">
                <select v-model="camera">
                  <option>-- Selecciona cámara --</option>
                  <option
                    v-for="device in devices"
                    :key="device.deviceId"
                    :value="device.deviceId"
                  >
                    {{ device.label }}
                  </option>
                </select>
              </div>
              <div class="col-md-12">
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="onCapture"
                >
                  Tomar foto
                </button>
              </div>
            </mdb-row>
          </mdb-col>
          <mdb-col v-if="imgSrc" md="6">
            <mdb-row>
              <h2>Foto Capturada</h2>
              <vue-cropper
                ref="cropper"
                :aspect-ratio="9 / 9"
                :src="imgSrc"
                preview=".preview"
              />
            </mdb-row>
            <mdb-row>
              <div class="col-md-12">
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="cropImage"
                >
                  Recortar
                </button>
              </div>
            </mdb-row>
          </mdb-col>
          <mdb-col v-if="imgSrc" md="12">
            <mdb-row>
              <div class="col-md-12">
                <h2>Vista Previa</h2>
                <div class="image-upload">
                  <label for="image-release">
                    <img
                      :src="imgSrc"
                      class="avatar-pic"
                      alt="Profile Picture"
                      style="cursor: pointer"
                    />
                  </label>
                </div>
              </div>
            </mdb-row>
            <mdb-row>
              <div class="col-md-12">
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="
                    $refs.camera.toggleModal();
                    $refs.webcam.stop();
                  "
                >
                  Finalizar edición
                </button>
              </div>
            </mdb-row>
          </mdb-col>
        </mdb-row>
      </div>
    </Popup>
    <Popup size="lg" ref="confirm" :title="titleModal">
      <div
        class="embed-responsive embed-responsive-16by9 z-depth-1-half"
        style="height: 75vh"
      >
        <iframe
          title="titulo"
          class="embed-responsive-item"
          :src="popUrl"
          allowfullscreen
        ></iframe>
      </div>
      <div class="accordion__button">
        <btn
          style="float: left"
          text="CERRAR"
          @onClick="$refs.confirm.toggleModal()"
          type="primary-block"
        />
      </div>
    </Popup>
  </div>
</template>


<script>
import { mdbContainer, mdbRow, mdbCol, mdbCard, mdbCardImage } from "mdbvue";
import btn from "../../../components/core/Button";
import HelperMessage from "../../core/HelperMessage";
import Axios from "axios";
import Swal from "sweetalert2";
import { mapMutations, mapState, mapGetters, mapActions } from "vuex";
import Loader from "../../../components/core/Loader";
import { WebCam } from "vue-web-cam";
import Popup from "../../core/Popup";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import {
  required,
  requiredIf,
  email,
  numeric,
  minLength,
  maxLength,
} from "vuelidate/lib/validators";
import { hasNumeric } from "../../../validations";
import ValidationError from "./../misc/ValidationError";
import { mask } from "vue-the-mask";

export default {
  name: "Update1",
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardImage,
    btn,
    HelperMessage,
    Loader,
    "vue-web-cam": WebCam,
    VueCropper,
    Popup,
    ValidationError,
  },
  directives: { mask },
  data() {
    return {
      curpValue: null,
      imgSrc: null,
      camera: null,
      deviceId: null,
      devices: [],
      curp: "",
      fileAvatar: "",
      estadoCivil: "MARRIED",
      uploadIcon: "upload-document.svg",
      releaseIcon: "release-default.svg",
      approvedIcon: "approved-2.svg",
      watchButton: "watch-unpressed-btn.svg",
      iconEdit: "editar-default.svg",
      iconDelete: "borrar-default.svg",
      showCard: false,
      filesCurp: null,
      filesIne: null,
      filesProfile: null,
      imageError: false,
      CURPimageError: false,
      IneImageError: false,
      candidates: [],
      isLoading: false,
      isCorrect: true,
      isInCorrect: false,
      urlAvatar: "",
      sexo: "",
      dia: "",
      mes: "",
      year: "",
      name: "",
      lastName: "",
      lastName2: "",
      state: "",
      step2: false,
      curpOK: false,
      ineOK: false,
      documentType: "",
      extension: "",
      extensionIne: "",
      messageIne: "",
      documentValue: "",
      popUrl: null,
      ////////
      pdfUrl: null,
      filesPDF: null,
      recomendations: [],
      singleRe: {
        firstName: "",
        lastName: "",
        motherLastName: "",
        accion: "",
        email: "",
        phone: "",
      },
      nameCompany: "",
      profession: "",
      businessActivity: "",
      addressCompany: "",
      phoneCompany: "",
      currentPosition: "",
      activityDescription: "",
      indexDelete: 0,
      ////////////////
      exCoupleName: "",
      exCoupleLastName: "",
      exCoupleMotherLastName: "",
      actaUrl: null,
      actaPDF: null,
      titleModal: "",
      fileCurp: null,
      fileIne: null,
      filePredial: null,
      fileEscrituras: null,
      filesPredial: null,
      filesEscrituras: null,
      numberR: 0,
      indexRecomendation: null,
      app: null,
    };
  },
  validations: {
    curp: { required },
    fileCurp: {
      required: requiredIf(function () {
        if (this.fileCurp != null) {
          return false;
        } else {
          return true;
        }
      }),
    },
    fileIne: {
      required: requiredIf(function () {
        if (this.fileIne != null) {
          return false;
        } else {
          return true;
        }
      }),
    },
    actaUrl: {
      required: requiredIf(function () {
        if (this.actaUrl != null) {
          return false;
        } else {
          return true;
        }
      }),
    },
    nameCompany: {
      required: requiredIf(function () {
        if (this.nameCompany != "") {
          return false;
        } else {
          return true;
        }
      }),
    },
      profession: {
      required: requiredIf(function () {
        if (this.profession != "") {
          return false;
        } else {
          return true;
        }
      }),
      },
      businessActivity: {
      required: requiredIf(function () {
        if (this.businessActivity != "") {
          return false;
        } else {
          return true;
        }
      }),
      },
      addressCompany: {
      required: requiredIf(function () {
        if (this.addressCompany != "") {
          return false;
        } else {
          return true;
        }
      }),
    },
    phoneCompany: {
      minLength: minLength(10),
      required: requiredIf(function () {
        if (this.phoneCompany != "") {
          return false;
        } else {
          return true;
        }
      }),
    },
    currentPosition: {
      required: requiredIf(function () {
        if (this.currentPosition != "") {
          return false;
        } else {
          return true;
        }
      }),
    },
    worker: {
      required: requiredIf(function () {
        if (this.pdfUrl != null) {
          return false;
        } else {
          return true;
        }
      }),
    },
    activityDescription: {
      required: requiredIf(function () {
        if (this.activityDescription != "" && !this.working) {
          return false;
        } else {
          return true;
        }
      })
    },
    singleRe: {
      firstName: {
        required: requiredIf(function () {
          return this.recomendations.length < this.numberR;
        }),
      },
      lastName: {
        required: requiredIf(function () {
          return this.recomendations.length < this.numberR;
        }),
      },
      motherLastName: {
        required: requiredIf(function () {
          return this.recomendations.length < this.numberR;
        }),
      },
      email: {
        required: requiredIf(function () {
          return this.recomendations.length < this.numberR;
        }),
        email,
      },
      phone: {
        required: requiredIf(function () {
          return this.recomendations.length < this.numberR;
        }),
        numeric,
        maxLength: maxLength(10),
      },
    },
  },
  methods: {
    ...mapActions([
      "getCurpInfo",
      "completeStep1",
      "postDataSpouse",
      "sendInvestigation",
      "recommendationsNumber",
      "updateBeneficiaries",
    ]),
 
    async readyToSend() {
      let data = {};
      data.id= this.spouseData[0].id;
      data.beneficiaryType= "SPOUSE";
      let docs = [];


        if(this.working){
          data.laborData =  {
            company: this.nameCompany,
            phone: this.phoneCompany,
            position: this.currentPosition,
            profession: this.profession,
            businessActivity: this.businessActivity,
            addressCompany: this.addressCompany,
          };
        }
        else {
          data.laborData = {
            activityDescription: this.activityDescription
          };
        }

      /*PROFILE PIC*/
     
      if (this.fileAvatar.split(",")[1]) {
        let aux = this.spouseData[0].documents.filter(function (item) {
        return item.documentType == "PROFILE_PICTURE";
      });
        docs.push({
          id: aux[0].id,
          documentType: "PROFILE_PICTURE",
          value: "",
          extension: "jpeg",
          mimeType: "image/jpeg",
          content: this.fileAvatar.split(",")[1],
        });
      }
      if (this.filesCurp) {
        let aux = this.spouseData[0].documents.filter(function (item) {
        return item.documentType == "CURP";
      });
        docs.push({
          id: aux[0].id,
          documentType: "CURP",
          value: this.curpValue,
          extension: "pdf",
          mimeType: "application/pdf",
          content: this.filesCurp,
        });
      }
      if (this.filesIne) {
        let aux = this.spouseData[0].documents.filter(function (item) {
        return item.documentType == "INE";
      });
        docs.push({
            id: aux[0].id,
          documentType: "INE",
          value: "",
          extension: "pdf",
          mimeType: "application/pdf",
          content: this.filesIne,
        });
      }
      if (this.actaPDF) {
        let aux = this.spouseData[0].documents.filter(function (item) {
        return item.documentType == "BIRTH_CERTIFICATE";
      });
        docs.push({
            id: aux[0].id,
          documentType: "BIRTH_CERTIFICATE",
          value: "",
          extension: "pdf",
          mimeType: "application/pdf",
          content: this.actaPDF,
        });
      }
      if (this.filesPDF) {
        let aux = this.spouseData[0].documents.filter(function (item) {
        return item.documentType == "TAX_STATUS_LETTER";
      });
        docs.push({
          id: aux.length>0 ? aux[0].id : '',
          documentType: "TAX_STATUS_LETTER",
          value: "",
          extension: "pdf",
          mimeType: "application/pdf",
          content: this.filesPDF,
        });
      }


      data.documents=docs

      let body ={beneficiaries:[]}
      body.beneficiaries.push(data)
   
      try {
        this.isLoading = true;
        let response = await this.updateBeneficiaries(body)
        this.isLoading = false;
        if (response.data.status == 200 || response.data.status == 201) {

          this.$notify.success({
            message: response.data.message,
            position: "top right",
            timeOut: 5000,
          });
           Swal.fire({
              title:
                "<span style='font-size: 25px; font-weight: 600; margin-top: 1rem;margin-bottom: -1rem; font-family: Josefin Sans; color: #828282'>¡ACTUALIZACIÓN REALIZADA!</span>",
              html:
                "<div style='text-align: center; padding-right: 3rem; padding-left: 3rem; font-size: 16px; font-family: Open Sans' color: #828282'>" +
                "<p>Gracias por actualizar tus datos/documentos. Ahora el proceso de trámite de admisión podrá continuar, espera respuesta del Club. Revisa tu correo constantemente.</p>" +
                // "<p style='padding-top: 1rem;'>El tiempo de espera de respuesta es de tres semanas aproximadamente, contando desde el día que realizas tu pago</p>" +
                "<p style='padding-top: 1rem;'>Toma en cuenta que las correcciones que realices por documentos o datos incorrectos enviados hace que el proceso demore un poco más.</p>" +
                "</div>",
              allowOutsideClick: false,
              width: "50rem",
              padding: "2rem",
              confirmButtonText: "OK",
              confirmButtonColor: "#dc7134",
              customClass: {
                confirmButton: "t1-btn t1-btn--primary-block",
              },
              onClose: () => {},
            }).then(() => {
              this.$router.push("/home");
            });
        }
        
      } catch (error) {
         this.isLoading = false;
          //console.log(error.response);
            this.$notify.error({
              message: error.response.data.errorDetails,
              position: "top right",
              timeOut: 15000,
            });

        
      }

    },
    async beforeEnter() {
   

      //DETALLES PERSONALES

      
        let aux = this.spouseData[0].documents.filter(function (item) {
          return item.documentType == "CURP";
        });

        this.fileCurp = aux[0].publicURL;
        this.curpValue = aux[0].value;

        aux = this.spouseData[0].documents.filter(function (item) {
          return item.documentType == "INE";
        });
        this.fileIne = aux[0].publicURL;

        aux = this.spouseData[0].documents.filter(function (item) {
          return item.documentType == "BIRTH_CERTIFICATE";
        });
        this.actaUrl = aux[0].publicURL;
      

      //DETALLES DE SOLICITUD
      
        aux = this.spouseData[0].documents.filter(function (item) {
          return item.documentType == "PROFILE_PICTURE";
        });
        this.fileAvatar = aux[0].publicURL;
      //LABOR DATA
        aux = this.spouseData[0].documents.filter(function (item) {
          return item.documentType == "TAX_STATUS_LETTER";
        });
        if(aux.length > 0)
          this.pdfUrl = aux[0].publicURL;

      this.nameCompany = this.spouseData[0].laborData.company
      this.phoneCompany = this.spouseData[0].laborData.phone
      this.currentPosition = this.spouseData[0].laborData.position
      this.activityDescription = this.spouseData[0].laborData.activityDescription
      this.profession = this.spouseData[0].laborData.profession
      this.businessActivity = this.spouseData[0].laborData.businessActivity
      this.addressCompany = this.spouseData[0].laborData.addressCompany
    },
    viewPdf(url, title) {
      this.popUrl = url;
      this.titleModal = title;
      this.$refs.confirm.toggleModal();
    },
    uploadWorker: function (evt) {
      this.pdfUrl = URL.createObjectURL(evt.target.files[0]);
      let aux = this;
      var rdr = new FileReader();
      rdr.onload = function (e) {
        aux.filesPDF = e.target.result.split(",")[1];
      };
      rdr.readAsDataURL(evt.target.files[0]);
    },
    uploadPredial: function (evt) {
      this.filePredial = URL.createObjectURL(evt.target.files[0]);
      let aux = this;
      var rdr = new FileReader();
      rdr.onload = function (e) {
        aux.filesPredial = e.target.result.split(",")[1];
      };
      rdr.readAsDataURL(evt.target.files[0]);
    },
    uploadEscrituras: function (evt) {
      this.fileEscrituras = URL.createObjectURL(evt.target.files[0]);
      let aux = this;
      var rdr = new FileReader();
      rdr.onload = function (e) {
        aux.filesEscrituras = e.target.result.split(",")[1];
      };
      rdr.readAsDataURL(evt.target.files[0]);
    },

    checkForm(form) {
      return (
        Object.keys(form).length ===
        Object.keys(form).filter((key) => form[key].length > 0).length
      );
    },
    cropImage() {
      // get image data for post processing, e.g. upload or setting image src
      this.imgSrc = this.$refs.cropper.getCroppedCanvas().toDataURL();
      this.fileAvatar = this.imgSrc;
      //console.log(this.fileAvatar)
    },
    reset() {
      this.fileAvatar = "";
      this.$refs.cropper.reset();
    },
    zoom(percent) {
      this.$refs.cropper.relativeZoom(percent);
    },
    move(offsetX, offsetY) {
      this.$refs.cropper.move(offsetX, offsetY);
    },
    mouseOverIcon(module) {
      if (module == "upload") {
        let uploadIcon = this.uploadIcon.split("-");
        this.uploadIcon = `${uploadIcon[0]}-document.svg`;
      } else if (module == "release") {
        let releaseIcon = this.releaseIcon.split("-");
        this.releaseIcon = `${releaseIcon[0]}-hover.svg`;
      } else {
        let helpIcon = this.helpIcon.split("-");
        this.helpIcon = `${helpIcon[0]}-hover.svg`;
        this.showCard = true;
      }
    },
    mouseLeaveIcon(module) {
      if (module == "upload") {
        let uploadIcon = this.uploadIcon.split("-");
        this.uploadIcon = `${uploadIcon[0]}-document.svg`;
      } else if (module == "release") {
        let releaseIcon = this.releaseIcon.split("-");
        this.releaseIcon = `${releaseIcon[0]}-default.svg`;
      } else if (module == "watch") {
        this.watchButton = "watch-unpressed-btn.svg";
      } else {
        let helpIcon = this.helpIcon.split("-");
        this.helpIcon = `${helpIcon[0]}-default.svg`;
        this.showCard = false;
      }
    },
    mouseDownIcon(module) {
      if (module == "upload") {
        let uploadIcon = this.uploadIcon.split("-");
        this.uploadIcon = `${uploadIcon[0]}-document.svg`;
      } else if (module == "watch") {
        this.watchButton = "watch-pressed-btn.svg";
      } else {
        let releaseIcon = this.releaseIcon.split("-");
        this.releaseIcon = `${releaseIcon[0]}-click.svg`;
      }
    },
    mouseUpIcon(module) {
      if (module == "upload") {
        let uploadIcon = this.uploadIcon.split("-");
        this.uploadIcon = `${uploadIcon[0]}-document.svg`;
      } else if (module == "watch") {
        this.watchButton = "watch-unpressed-btn.svg";
      } else {
        let releaseIcon = this.releaseIcon.split("-");
        this.releaseIcon = `${releaseIcon[0]}-hover.svg`;
      }
    },
    UploadIdentificacion: function (evt) {
      this.fileIne = URL.createObjectURL(evt.target.files[0]);
      this.extensionIne = evt.target.files[0].type;
      let aux = this;
      var rdr = new FileReader();
      rdr.onload = function (e) {
        aux.filesIne = e.target.result.split(",")[1];
        //aux.isLoading = true;
        //aux.readIne(aux.filesIne);
      };
      rdr.readAsDataURL(evt.target.files[0]);
    },
    uploadCURP: function (evt) {
      this.fileCurp = URL.createObjectURL(evt.target.files[0]);
      this.extension = evt.target.files[0].type;
      let aux = this;
      var rdr = new FileReader();
      rdr.onload = function (e) {
        aux.filesCurp = e.target.result.split(",")[1];
        //aux.isLoading = true;
        //aux.readCurp(aux.filesCurp);
      };
      rdr.readAsDataURL(evt.target.files[0]);
    },
    cleanCurp() {
      this.curp = "";
      this.fileCurp = "";
    },
    validateFile() {
      var d = new Date();
      var n = d.getFullYear();
      if (n - Number(this.year) >= 18) {
        return true;
      } else {
        return false;
      }
    },
    uploadActa: function (evt) {
      this.actaUrl = URL.createObjectURL(evt.target.files[0]);
      let aux = this;
      var rdr = new FileReader();
      rdr.onload = function (e) {
        aux.actaPDF = e.target.result.split(",")[1];
      };
      rdr.readAsDataURL(evt.target.files[0]);
    },
    uploadFile: function (evt) {

      this.fileAvatar = URL.createObjectURL(evt.target.files[0]);
      let aux = this;
      var rdr = new FileReader();
      rdr.onload = function (e) {
        aux.filesProfile = e.target.result.split(",")[1];
      };
      rdr.readAsDataURL(evt.target.files[0]);
    },
    ...mapActions(["logOut"]),
    async logout() {
      await this.logOut();
      this.$router.push("/");
    },
    onCapture() {
      this.imgSrc = this.$refs.webcam.capture();
      this.$refs.cropper.replace(this.imgSrc);
      //this.$refs.camera.toggleModal();
      //this.$refs.webcam.stop();
      //this.fileAvatar = this.imgSrc;
    },
    onStarted(stream) {
      //console.log("On Started Event", stream);
    },
    onStopped(stream) {
      //console.log("On Stopped Event", stream);
    },
    onStop() {
      this.$refs.webcam.stop();
    },
    onStart() {
      this.$refs.webcam.start();
    },
    onError(error) {
      //console.log("On Error Event", error);
    },
    onCameras(cameras) {
      this.devices = cameras;
      //console.log("On Cameras Event", cameras);
    },
    onCameraChange(deviceId) {
      this.deviceId = deviceId;
      this.camera = deviceId;
      //console.log("On Camera Change Event", deviceId);
    },
    closeMessageError() {
      Swal.fire({
        title:
          "<span style='font-size: 25px; font-weight: 600; margin-top: 1rem;margin-bottom: -1rem; font-family: Josefin Sans; color: #dc7134'>¡ATENCIÓN!</span>",
        html:
          "<div style='text-align: center; padding-right: 3rem; padding-left: 3rem; font-size: 16px; font-family: Open Sans' color: #828282'>" +
          "<p>¿Estás seguro de cerrar la ventana para crear tu solicitud? Si haces esto la solicitud no será generada.</p>" +
          "<p style='padding-top: 1rem;'> <img src='/img/icons/InoAlerta.svg' alt='Alerta'/> </p>" +
          "</div>",
        allowOutsideClick: false,
        showCancelButton: true,
        width: "50rem",
        padding: "2rem",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Aceptar",
        confirmButtonColor: "#dc7134",
        customClass: {
          cancelButton: "t1-btn t1-btn--ghost",
          confirmButton: "t1-btn t1-btn--primary-block",
        },
        reverseButtons: true,
        onClose: () => {},
      }).then((result) => {
        if (result.value) {
          this.$router.push("/home");
        }
      });
    },
  },
  created(){},
  async mounted() {
    //this.$refs.webcam.stop();
    
    await this.beforeEnter();
  },
  computed: {
    ...mapGetters({
      ap: "getAllApplicationData",
    }),
    working () {
      if(this.spouseData.length>0)
        return this.spouseData[0].laborData.working
      else
        return false
    },
    treeImg() {
     return "/img/tree/Wizard2-Conyuge-06.svg"
    },
    device: function () {
      return this.devices.find((n) => n.deviceId === this.deviceId);
    },
    displayedPost() {
      return this.recomendations;
    },
    spouseData(){
      return this.ap.beneficiaries.filter(function (item) {
        return item.beneficiaryType == "SPOUSE";
      });

    },
    correctionsSpouse () {
      let correctionsSpouse = []
       this.ap.application.corrections.forEach( (item) => {
        if(item.editAt === null){
          var aux = JSON.parse(item.jsonCorrections)
          aux.beneficiaries.forEach( (item2) => {
            if(item2.beneficiaryType === 'SPOUSE'){
            correctionsSpouse.push(item2)
        }
      })
        }
      })
  
      return correctionsSpouse;
    },
  },
  watch: {
    fileAvatar(value) {
      if (value != "") {
        this.imageError = false;
      }
    },
    fileCurp(value) {
      if (value != "") {
        this.CURPimageError = false;
      }
    },
    fileIne(value) {
      if (value != "") {
        this.IneImageError = false;
      }
    },

    isCorrect(newValue) {
      this.isInCorrect = !newValue;
    },
    isInCorrect(newValue) {
      this.isCorrect = !newValue;
    },
    camera: function (id) {
      this.deviceId = id;
    },
    devices: function () {
      // Once we have a list select the first one
      const [first, ...tail] = this.devices;
      if (first) {
        this.camera = first.deviceId;
        this.deviceId = first.deviceId;
      }
    },
  },
};
</script>


<style scoped>
.input-group-prepend > input::placeholder {
  font-size: 14px;
}

.uploadIcon {
  cursor: pointer;
  background-color: rgb(220, 113, 52);
  padding: 9.4px;
  border-radius: 0px 4px 4px 0px;
  /* margin-top: 12px;
    margin-left: 20px; */
}

.approvedIcon {
  width: 5rem;
}

.class-container {
  background: #fff !important;
  height: 100%;
  width: 100%;
  padding-top: 1rem;
  padding-bottom: 9vh;
}
.center {
  margin: auto;
  margin-top: 120px;
  width: 60%;

  padding-bottom: 20%;
}

.text-style {
  font-size: 27px;
  color: #285f46;
  font-weight: 600;
  text-transform: uppercase;
}
.text-style-2 {
  font-size: 20px;
  color: #285f46;
  font-weight: normal;
}

.Rectangle-78 {
  width: 100%;
  padding: 1rem;
  height: 100%;
  border: 1px solid #285f46;
}

.Rectangle-366 {
  width: 882px;
  height: 205px;
  border-radius: 5px;
  border: solid 1px #3a8a65;
}

.btn-crear {
  width: 10rem;
  height: 3rem;
  border-radius: 3.5px;
  background-color: #dc7134;
  color: #ffffff;
  font-size: 12px;
}

.btn-cancelar {
  width: 11.5rem;
  height: 3rem;
  border: 1px solid #bdbdbd;
  border-radius: 3.5px;
  background-color: #ffffff;
  color: #bdbdbd;
  font-size: 12px;
}

.curp-upload > input {
  display: none;
}

.image-upload > input {
  display: none;
}

.btn-label {
  border-radius: 5px;
  background-color: #dc7134;
  padding: 0.4rem 2.5rem;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #ffffff;
  font-weight: 600;
  font-family: Josefin Sans;
  cursor: pointer;
}

.btn-edit {
  padding: 6px;
  background-color: #c4c4c4 !important;
  border-radius: 3px;
  box-shadow: unset;
}
.btn-edit:hover {
  background-color: #f78c4f !important;
}
.btn-edit:active {
  background-color: #dc7134 !important;
}

.btn-delete {
  padding: 6px;
  background-color: #c4c4c4 !important;
  border-radius: 3px;
  box-shadow: unset;
}

.btn-delete:hover {
  background-color: #eb5757 !important;
}

.btn-delete:active {
  background-color: #d65050 !important;
}

.divLine {
  width: 100%;
  border: 0.1rem solid #828282;
}

.edit-pic {
  cursor: pointer;
  position: absolute;
  z-index: 100;
}
.avatar-pic {
  /* position: absolute; */
  /* border: 0.6rem solid #285f46; */
  border-radius: 50%;
  width: 13rem;
  height: 13rem;
}

.help-curp {
  width: 29rem;
  position: absolute;
  bottom: 0rem;
  z-index: 10000;
}

.split {
  border: 0.15rem solid #bdbdbd;
  font-size: 1.5rem;
  padding: 0.6rem 1rem;
  border-radius: 0.8rem;
  width: 30%;
  color: #828282;
  transition: all 0.2s;
  text-align: center;
}

.form-check-input[type="checkbox"]:checked + label:before,
label.btn input[type="checkbox"]:checked + label:before {
  top: -4px;
  /* left: -5px; */
  width: 11px;
  height: 18px;
  border-top: 2px solid transparent;
  border-right: 2px solid #f78c4f;
  border-bottom: 2px solid #f78c4f;
  border-left: 2px solid transparent;
  -webkit-transform: rotate(40deg);
  transform: rotate(40deg);
  -webkit-transform-origin: 100% 100%;
  transform-origin: 100% 100%;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.form-check-input[type="checkbox"] + label:before,
.form-check-input[type="checkbox"]:not(.filled-in) + label:after,
label.btn input[type="checkbox"] + label:before,
label.btn input[type="checkbox"]:not(.filled-in) + label:after {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
  width: 18px;
  height: 18px;
  margin-top: 3px;
  content: "";
  border: 2px solid #8a8a8a;
  border-radius: 1px;
  -webkit-transition: 0.2s;
  transition: 0.2s;
}

@media (max-width: 80.2rem) {
  .cardClass {
    padding-bottom: 3rem;
  }
}

@media (min-height: 850px) {
  .class-container {
    padding-bottom: 40vh;
  }
  /* .uploadIcon{
    margin-top: 3px;

} */
}

.table td {
  font-size: 12px;
  font-family: Open Sans;
  text-transform: uppercase;
}

.btn-acta-nacimiento {
  display: inline-block;
  margin-left: 10px;
}
</style>